// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"7012b9f8","2479":"6cdc6562","7379":"75307b01","7872":"ee810658","8485":"c32367a7","8966":"0eca671b","9386":"4843146e"}[chunkId] + ".chunk.css";
};